import React, { useEffect, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { jwtVerify } from 'jose';
import { UserContext } from './UserContext';

const SECRET_KEY = new TextEncoder().encode(process.env.REACT_APP_JWT_SECRET_KEY);

const TokenHandler = () => {
    const location = useLocation();
    const { setUser, setLoading } = useContext(UserContext);

    const redirectToLogin = () => {
        setLoading(false);
        const currentUrl = window.location.href;
        const encodedUrl = encodeURIComponent(currentUrl);

        if (!sessionStorage.getItem("login_attempted")) {
            sessionStorage.setItem("login_attempted", "1");
            window.location.href = `https://wocaicai.online/?verify_user_from_lobby_redirect=true&next_Red=${encodedUrl}`;
        } else {
            //console.warn("⚠️ Already attempted login once. Avoiding redirect loop.");
        }
    };

    const verifyAndSetUserFromToken = async (token, nextRed) => {
        setLoading(true);
        try {
            const { payload } = await jwtVerify(token, SECRET_KEY);
            const isExpired = payload.exp <= Math.floor(Date.now() / 1000);
            if (isExpired) throw new Error("Token expired");

            const userData = {
                user_id: payload.user_id,
                username: payload.username,
                email: payload.email,
                name: payload.name,
            };

            setUser(userData);
            sessionStorage.setItem("lobby_user", JSON.stringify(userData));
            sessionStorage.removeItem("login_attempted");

            // ✅ Redirect to next_Red after setting user
            if (nextRed) {
                const decodedNext = decodeURIComponent(nextRed);
                console.log("🚀 Redirecting to:", decodedNext);
                window.location.href = decodedNext;
                return; // ✅ Important: prevent further execution
            }

            // 🧹 Clean the token from the URL only if no redirect
            const cleanedSearch = location.search
                .replace(/[\?&]?token=[^&]*/g, '')
                .replace(/[\?&]?next_Red=[^&]*/g, '')
                .replace(/^&|^\?&?/, '?')
                .replace(/&$/, '');

            const cleanUrl = location.pathname + cleanedSearch;
            window.history.replaceState({}, "", cleanUrl);
        } catch (err) {
            console.warn("❌ Token invalid or expired:", err.message);
            sessionStorage.removeItem("lobby_user");
            redirectToLogin();
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const urlToken = params.get("token");
        const nextRed = params.get("next_Red");

        if (urlToken) {
            verifyAndSetUserFromToken(urlToken, nextRed);
        } else {
            const storedUser = sessionStorage.getItem("lobby_user");
            if (storedUser) {
                try {
                    const userObj = JSON.parse(storedUser);
                    setUser(userObj);
                    setLoading(false);
                    sessionStorage.removeItem("login_attempted");
                } catch {
                    redirectToLogin();
                }
            } else {
                redirectToLogin();
            }
        }
    }, [location, setUser, setLoading]);

    return null;
};

export default TokenHandler;
